import { IconButton } from '@mui/material';
import type { MenuProps } from 'antd';
import { Avatar, Dropdown } from 'antd';
import clsx from 'clsx';
import AppBreadcrumbs from 'components/AppBreadcrumbs';
import AltArrowDownOutlineIcon from 'components/AppIcon/AltArrowDownOutlineIcon';
import LogoutOutlineIcon from 'components/AppIcon/LogoutOutlineIcon';
import MagnifierOutlineIcon from 'components/AppIcon/MagnifierOutlineIcon';
import UserRoundedOutlineIcon from 'components/AppIcon/UserRoundedOutlineIcon';
import { TOKEN } from 'features/auth/constants';
import { clearAuthToken, getAuthToken } from 'features/auth/helpers';
import NotificationPanel from 'features/notification/components/NotificationPanel';
import { KEYCLOAK_CONFIG } from 'lib/keycloak/keycloak';
import { memo, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';
import { routerUtils } from 'utils/utils';

const AppMainNavigationTabBar = () => {
  routerUtils.navigate = useNavigate();
  routerUtils.location = useLocation();

  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === '/';

  const menuItems: MenuProps['items'] = [
    {
      key: getPath('UserProfilePage'),
      label: 'Thông tin cá nhân',
      icon: <UserRoundedOutlineIcon className="h-5 w-5 text-[#006eb3]" />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Đăng xuất',
      danger: true,
      icon: <LogoutOutlineIcon className="h-5 w-5" />,
    },
  ];

  const onUserMenuClick = useCallback(
    ({ key }: { key: string }): MenuProps['onClick'] => {
      if (key === 'darkMode') {
        return;
      }

      if (key !== 'logout') {
        navigate(key);
        return;
      }

      const token = getAuthToken(TOKEN.KC_TOKEN) as string;
      if (!token) {
        navigate(getPath('loginPage'));
        return;
      }

      const logoutUrl = new URL(
        `${KEYCLOAK_CONFIG.url}/realms/${KEYCLOAK_CONFIG.realm}/protocol/openid-connect/logout`
      );
      logoutUrl.searchParams.append('client_id', KEYCLOAK_CONFIG.clientId);
      logoutUrl.searchParams.append('id_token_hint', token);
      logoutUrl.searchParams.append(
        'post_logout_redirect_uri',
        `${window.location.origin}${getPath('loginPage')}`
      );

      clearAuthToken();

      window.location.href = logoutUrl.toString();
      return;
    },
    [navigate]
  );

  return (
    <div
      className={clsx(
        'flex items-center justify-between py-4',
        !isHome && 'border-b border-b-[#E3E8EF]'
      )}
    >
      <div className="flex-1">
        <AppBreadcrumbs />
      </div>
      <div className="flex items-center justify-end gap-3">
        <IconButton className="h-8 w-8">
          <MagnifierOutlineIcon className="shirk-0 h-5 w-5 cursor-pointer text-black" />
        </IconButton>

        <NotificationPanel />

        <Dropdown
          menu={{ items: menuItems, onClick: onUserMenuClick }}
          trigger={['click']}
        >
          <div className="flex cursor-pointer items-center justify-end gap-5">
            <div className="flex items-center justify-end gap-2">
              <Avatar
                size={44}
                className="shirk-0"
                src="https://i.pravatar.cc/150?img=47"
              />

              <div>
                <p className="text-sm font-medium">Administrator</p>
                <p className="text-xs text-black opacity-40">Tổng giám đốc</p>
              </div>
            </div>

            <AltArrowDownOutlineIcon className="h-5 w-5 text-black" />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default memo(AppMainNavigationTabBar);
